import SrQiankunView from "./SrQiankunView.vue";

SrQiankunView.install = function(Vue) {
  Vue.component(SrQiankunView.name, SrQiankunView);
};

export default SrQiankunView;


// WEBPACK FOOTER //
// ./packages/SrQiankunView/index.js